import { useMemo } from "react";
import { useDailyTaskDwo } from "./hooks/useDailyTaskDwo";
import { MediaItem } from "./types/dailyTaskDwo";
import DailyTaskDetailsDwo from "./DailyTaskDetailsDwo";
import MediaView from "./MediaView";
import OldMediaView from "./OldMediaView";
import { OldMediaItem } from "./types/oldMedia";
import { useGetMedia } from "./hooks/useMedia";
import { VIEW_MEDIA_URL } from "src/redux/api/appConst";

const MEDIA_SECTIONS: { type: MediaItem["type"]; label: string }[] = [
  { type: "image", label: "Activity Geotagged Photos" },
  {
    type: "video",
    label: "Approval Letter Submission & Activity Geotagged Videos",
  },
  { type: "document", label: "Approval Letter Submission Geotagged Photos" },
];

const groupByType = (items: MediaItem[]) =>
  MEDIA_SECTIONS.map(({ type, label }) => ({
    type,
    label,
    items: items?.filter((item) => item.type === type),
  })).filter((section) => section.items?.length > 0);

export const oldGroupByType = (items: OldMediaItem[] = []) =>
  MEDIA_SECTIONS.map(({ type, label }) => ({
    type,
    label,
    items: items.filter((item) => item.type === type),
  })).filter((section) => section.items.length > 0);

const DwoView = ({
  attendanceId,
  role,
}: {
  attendanceId: string;
  role: string;
}) => {
  const { data = [], isLoading } = useDailyTaskDwo(attendanceId);
  const { data: oldMedia = [], isLoading: loadingMedia } =
      useGetMedia(attendanceId);

  const taskData = data[0];
  const media = taskData?.media;

  const grouped = useMemo(() => groupByType(media), [media]);
  const oldGrouped = useMemo(() => oldGroupByType(oldMedia), [oldMedia]);
  
    const handleOldView = (item: OldMediaItem) => {
      const url = `${VIEW_MEDIA_URL}/${item.key}`;
      if (item.type === "document") {
        window.open(url, "_blank", "noopener,noreferrer");
        return;
      }
      // setOldViewer({ open: true, item, url });
    };

  if (isLoading) {
    return (
      <div className="p-6 text-center bg-gray-900 border  border-gray-700 rounded-2xl shadow animate-pulse">
        <div className="text-gray-500 dark:text-gray-400 flex items-center justify-center gap-4 h-[10dvh]">
          <span>Loading...</span>{" "}
          <span className="loading loading-ring loading-lg"></span>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto">
      {taskData && (
        <div className="bg-white border border-gray-100 rounded-2xl shadow-sm overflow-hidden">
          <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200">
            <h3 className="font-bold text-gray-800 text-base">
              Today's Task Data
            </h3>
          </div>

          <div className="p-2">
            <MediaView
              media={media}
              grouped={grouped}
              attendanceId={attendanceId}
              role={role}
            />
          </div>

          <DailyTaskDetailsDwo task={taskData} />
        </div>
      )}

      {!loadingMedia && oldMedia && oldMedia?.length > 0 && (
        <div className="bg-white border border-gray-100 rounded-2xl shadow-sm overflow-hidden max-w-6xl mx-auto">
          <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
            <div>
              <h3 className="font-bold text-gray-800 text-base">
                Today's Task Data
              </h3>
            </div>
          </div>

          <div className="p-5">
            <OldMediaView
              media={oldMedia}
              handleView={handleOldView}
              grouped={oldGrouped}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DwoView;
